export default __webpack_public_path__ + "static/media/icon-key.fb54ae64.svg";